import React, { HTMLAttributes, forwardRef } from "react";
import "./header.css";

export interface HeaderUIProps {
    uiSize?: string | number;
}

export type HeaderProps = HTMLAttributes<HTMLHeadingElement> & HeaderUIProps;

const Header = forwardRef<HTMLHeadingElement, HeaderProps>((props, ref) => {
    const {
        uiSize = "1.25em",
        className,
        children,
        style,
        ...other
    } = props;

    const classes = [
        "ui-header",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    const computedSize = typeof uiSize === "number" ? `${uiSize}rem` : uiSize;

    const inlineStyle: React.CSSProperties = {
        ...style,
        fontSize: computedSize,
    };

    return (
        <h1 ref={ref} className={classes} style={inlineStyle} {...other}>
            {children}
        </h1>
    );
});

Header.displayName = "Header";

export default Header;
